<template>
  <div>
    <section
      class="invoice box box-primary"
      style="border: 0px solid #f4f4f4;margin:0px 0px;border-top: 3px solid #3c8dbc;border-radius: 3px;"
    >
      <div class="page-header">
        <h3 class="box-title" style="font-size:18px;">Service History</h3>
      </div>

      <div class>
        <!-- Custom Tabs -->
        <div class="nav-tabs-custom">
          <ul class="nav nav-tabs">
            <li :class="{active:active_tab_input}" @click="onShowInputNewUsage">
              <a
                id="tabinput"
                href="#tab_input"
                data-toggle="tab"
                :aria-expanded="true"
              >Input New Usage</a>
            </li>
            <li :class="{active:active_tab_history}" @click="onLoadHistoryService">
              <a href="#tab_history" data-toggle="tab" aria-expanded="false">History Usage</a>
            </li>
            <li :class="{active:active_tab_invoice}" @click="onShowCommingSoon">
              <a href="#tab_invoice" data-toggle="tab" aria-expanded="false">Invoice By User</a>
            </li>
          </ul>

          <div class="tab-content">
            <div class="tab-pane active" id="tab_input">
              <b-form @submit="onSubmit">
                <b-form-group label="Services Available:" label-for="shservices">
                  <b-form-select
                    :options="services"
                    required
                    v-model="form.service_name"
                    class="form-control"
                  />
                </b-form-group>

                <b-form-group label="Last Value:" label-for="shlastvalue">
                  <b-form-input
                    type="number"
                    v-model="form.last_value"
                    placeholder="Enter Last Value"
                  />
                </b-form-group>

                <b-form-group label="Current Value:" label-for="shlastvalue">
                  <b-form-input
                    type="number"
                    v-model="form.current_value"
                    placeholder="Enter Current Value"
                  />
                </b-form-group>

                <!-- Date From -->
                <div class="form-group">
                  <label>Date From:</label>

                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <date-picker v-model="form.dateFrom" :config="options"></date-picker>
                  </div>
                </div>

                <div class="form-group">
                  <label>Date To:</label>

                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <date-picker v-model="form.dateTo" :config="options"></date-picker>
                  </div>
                  <!-- /.input group -->
                </div>
                <!-- /.form group -->
                <b-button
                  ref="formsubmitbutton"
                  type="submit"
                  variant="primary"
                  style="display: none;"
                >Submit</b-button>
              </b-form>
              <button type="button" class="btn btn-primary" @click="onSave">Save changes</button>
            </div>

            <!-- /.tab-pane -->
            <div class="tab-pane" id="tab_history">
              <div>
                <b-table :items="items" :fields="fields" class="mt-3" outlined>
                  <template slot="status" slot-scope="row">
                    <span class="label label-success" v-if="row.value === 'paid'">Paid</span>
                    <span class="label label-warning" v-else-if="row.value === 'open'">Open</span>
                    <span class="label label-primary" v-else-if="row.value === 'issued'">Issued</span>
                  </template>

                  <template slot="actions" slot-scope="row">
                    <div class="btn-group dropup">
                      <button
                        type="button"
                        class="btn btn-danger dropdown-toggle"
                        data-toggle="dropdown"
                      >
                        Actions
                        <span class="caret"></span>
                        <span class="sr-only">Toggle Dropdown</span>
                      </button>
                      <ul class="dropdown-menu" role="menu">
                        <li>
                          <a
                            @click="showRecordHistory(row.item, row.index, $event.target)"
                          >Record History</a>
                        </li>
                        <li>
                          <a @click="info(row.item, row.index, $event.target)">Edit</a>
                        </li>
                        <li class="disabled">
                          <a>Delete</a>
                        </li>
                      </ul>
                    </div>
                  </template>
                </b-table>
                <div class="box-footer clearfix" style="display:contents;">
                  <ul class="pagination pagination-sm no-margin pull-right" v-if="PAGINATOR.length">
                    <li v-bind:disabled="PAGE_ARROW.prev===null" @click="onPrevPagination">
                      <a>&laquo;</a>
                    </li>
                    <li
                      v-for="(page, index) in PAGINATOR"
                      :key="index"
                      :value="page.value"
                      @click="onPagination(page.value)"
                    >
                      <a>{{ page.text }}</a>
                    </li>
                    <li v-bind:disabled="PAGE_ARROW.next===null" @click="onNextPagination">
                      <a>&raquo;</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- /.tab-pane -->
            <div class="tab-pane" id="tab_invoice">We will develop this function as soon as posible.</div>
            <!-- /.tab-pane -->
          </div>
          <!-- /.tab-content -->
        </div>
        <!-- nav-tabs-custom -->
      </div>

      <div class="box-body">
        <button
          type="button"
          class="btn btn-success pull-right"
          style="margin-right: 5px;"
          @click="onClickClose"
        >{{$t('common.cancel')}}</button>

        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>

        <!-- Modal Component -->
        <div class="modal fade" id="modal-inputnewusage">
          <div
            class="modal-dialog"
            style="border:1px solid #999;width:90%;height:auto;overflow-y:auto;max-height: 90%;"
          >
            <div class="modal-content">
              <div class="modal-header" style="background-color:beige;">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Record History</h4>
              </div>
              <div class="modal-body">
                <b-table :items="items_history" :fields="fields_history" class="mt-3" outlined></b-table>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Close</button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LTEModal from "@/components/LTEModal.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import utils from '@/lib/utils'

export default {
  name: "ServiceHistory",
  data() {
    return {
      services: [{ text: "Select One", value: null, type: null }],
      options: {
        //format: 'DD/MM/YYYY',
        format: "",
        useCurrent: false
      },
      active_tab_input: true,
      active_tab_history: false,
      active_tab_invoice: false,
      form: {
        dateFrom: new Date(),
        dateTo: new Date(),
        service_name: null,
        last_value: null,
        current_value: null,
        id: 0
      },
      show: true,
      fields: [
        {
          key: "service_name",
          label: "Service Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "date_from",
          label: "Date From",
          sortable: true,
          class: "text-center"
        },
        {
          key: "date_to",
          label: "Date To",
          sortable: true,
          class: "text-center"
        },
        {
          key: "last_value",
          label: "Last Value",
          sortable: true,
          class: "text-center"
        },
        {
          key: "current_value",
          label: "Current Value",
          sortable: true,
          class: "text-center"
        },
        {
          key: "total_fee",
          label: "Total Fee",
          sortable: true,
          class: "text-center"
        },
        {
          key: "user_record",
          label: "User Record",
          sortable: true,
          class: "text-center"
        },
        { key: "status", label: "Status", class: "text-center" },
        { key: "invoice", label: "Invoice", class: "text-center" },
        { key: "actions", label: "Actions", class: "text-center" }
      ],
      items: [],
      fields_history: [
        {
          key: "date_created",
          label: "Date Created",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "date_updated",
          label: "Date Updated",
          sortable: true,
          class: "text-center"
        },
        {
          key: "action",
          label: "Action",
          sortable: true,
          class: "text-center"
        },
        {
          key: "platform",
          label: "Platform",
          sortable: true,
          class: "text-center"
        },
        {
          key: "user_record",
          label: "User Record",
          sortable: true,
          class: "text-center"
        }
      ],
      items_history: [],
      isModalVisible: false,
      objModal: [
        {
          title: "Comming Soon",
          body: "We will develop this function as soon as posible.",
          buttonNo : "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ]
    };
  },
  watch: {
    SERVICE_HISTORY_DATA: function() {
      this.items = [];
      this.SERVICE_HISTORY_DATA.forEach(service_history => {
        let service_name = service_history.service_name;
        let date_from = utils.formatSqlDate(service_history.date_from, null, "DD-MMM");
        let date_to = utils.formatSqlDate(service_history.date_to, null, "DD-MMM");
        let last_month_value = service_history.last_month_value;
        let this_month_value = service_history.this_month_value;
        let total_fees = service_history.total_fees;
        let invoice = service_history.invoice;
        let status = service_history.status;
        let user_record = service_history.user_record;
        let id = service_history.id;
        let data = {
          id: id,
          service_name: service_name,
          date_from: date_from,
          date_to: date_to,
          last_value: last_month_value,
          current_value: this_month_value,
          total_fee: total_fees,
          status: status,
          invoice: invoice,
          user_record: user_record
        };
        this.items.push(data);
      });

      return this.items;
    },

    SERVICE_RECORD_HISTORY_DATA: function() {
      this.items_history = [];
      this.SERVICE_RECORD_HISTORY_DATA.forEach(service_record_history => {
        let date_updated = utils.formatSqlDate(service_record_history.date_updated, null, "DD-MMM");
        let date_created = utils.formatSqlDate(service_record_history.date_created, null, "DD-MMM");
        let action = service_record_history.action;
        let platform = service_record_history.platform;
        let user_record = service_record_history.user_record;
        let id = service_record_history.id;
        let data = {
          id: id,
          date_updated: date_updated,
          date_created: date_created,
          action: action,
          platform: platform,
          user_record: user_record
        };
        this.items_history.push(data);
      });

      return this.items_history;
    }
  },
  computed: {
    ...mapGetters([
      // "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "SERVICE_HISTORY_DATA",
      "GET_ACCOUNT_DATA",
      "SERVICE_RECORD_HISTORY_DATA"
    ])
  },
  methods: {
    fullName(value) {
      return `${value.first} ${value.last}`;
    },
    onClickClose: function() {
      this.$router.push({
        name: "CustomerAdd"
      });
    },
    onSave() {
      this.$refs.formsubmitbutton.click();
    },
    onSubmit(evt) {
      evt.preventDefault();
      //$("#modal-inputnewusage").modal("hide");
      let payload = {};
      payload = {
        date_from: this.form.dateFrom,
        date_to: this.form.dateTo,
        serviceuser: this.form.service_name,
        //"user"      : this.form.user,
        last_month_value: parseInt(this.form.last_value),
        this_month_value: parseInt(this.form.current_value),
        description: "Insert New Usage",
        user_created: this.GET_ACCOUNT_DATA.id,
        id: this.form.id
      };
      if (this.form.id != 0) {
        //Update
        this.UPDATE_USAGE_SERVICE(payload)
          .then(
            function() {
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function() {
              this.ERROR_TOAST();
            }.bind(this)
          );
      } else {
        //Insert
        this.ADD_NEW_USAGE_SERVICE(payload)
          .then(
            function() {
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function() {
              this.ERROR_TOAST();
            }.bind(this)
          );
      }
    },
    info(item, index, button) {
      var self = this; // <-- declare self
      $("a#tabinput").trigger("click");

      self.active_tab_history = false;
      self.active_tab_invoice = false;
      self.active_tab_input = true;

      this.form.date_from = item.date_from;
      this.form.date_to = item.date_to;
      this.form.service_name = item.service_name;
      this.form.last_value = item.last_value;
      this.form.current_value = item.current_value;
      this.form.id = item.id;
    },
    showRecordHistory(item, index, button) {
      $("#modal-inputnewusage").modal("show");
      this.GET_RECORD_HISTORY_LIST({ serviceusageid: item.id });
    },
    onShowInputNewUsage() {
      this.form.date_from = "";
      this.form.date_to = "";
      this.form.service_name = null;
      this.form.last_value = null;
      this.form.current_value = null;
      this.form.id = 0;
    },
    onLoadHistoryService() {
      this.userui = this.$route.params.id;
      const data = {
        params: {
          page: 1,
          userid: this.userui
        }
      };
      this.GET_SERVICE_HISTORY_LIST(data);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onConfirm() {
      this.isModalVisible = false;
    },
    onShowCommingSoon() {
      this.isModalVisible = true;
    },
    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_SERVICE_HISTORY_LIST"
      };
      this.PAGINATION_PREV_PAGE(data);
    },
    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_SERVICE_HISTORY_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },
    onPagination: function(value) {
      if (value === 0) return false;
      // this.userui = this.$route.params.id;
      const data = {
        params: {
          page: value,
          userid: this.userui
        }
      };
      this.GET_SERVICE_HISTORY_LIST(data);
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_SERVICE_HISTORY_LIST",
      "GET_SERVICE_LIST_BY_USER",
      "ADD_NEW_USAGE_SERVICE",
      "UPDATE_USAGE_SERVICE",
      "GET_RECORD_HISTORY_LIST"
    ])
  },
  components: {
    "date-picker": datePicker,
    "lte-modal": LTEModal
  },
  mounted() {
    this.userui = this.$route.params.id;
    const data = {
      params: {
        page: 1,
        userid: this.userui
      }
    };
    this.GET_SERVICE_HISTORY_LIST(data);
    this.GET_SERVICE_LIST_BY_USER({ userid: this.userui }).then(
      function(res) {
        let result = res.data;
        result.forEach(v => {
          let data = {
            text: v.service_name,
            value: v.id,
            service: v.service
          };
          this.services.push(data);
        });
      }.bind(this)
    );
  }
};
</script>

<style scoped>
.dropdown-menu {
  min-width: 80px;
}
</style>


// WEBPACK FOOTER //
// src/views/Service/ServiceHistory.vue